export const CARGO_PAGES = {
  TRANSPORT: "transport",
  HANDLING: "handling",
};
